"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _Facts = require("../../constants/Facts");
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _translation = _interopRequireDefault(require("../../Translation/translation"));
var _lodash = require("lodash");
var _reactRedux = require("react-redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelExtraFeatureComponent = props => {
  const {
    className = '',
    country = '',
    disabled = false,
    extraFeatureCustomList = null,
    iconClass = '',
    input,
    lang,
    pdClass = '',
    translations,
    validation = false
  } = props;
  const [arrVal, setArrVal] = (0, _react.useState)(input.value || {});
  const [up, setUp] = (0, _react.useState)(0);
  const valArr = arrVal || {};
  const onChange = val => {
    const value = (0, _cloneDeep.default)(input.value || {});
    if (value[val]) value[val] = false;else value[val] = true;
    delete value.value;
    setArrVal(value);
    setUp(up + 1);
    if (input.onChange) input.onChange(value);
  };
  (0, _react.useEffect)(() => {
    setArrVal(input.value || {});
  }, [input.value]);
  let extraFeatureList = _Facts.factsOptions.extraFeature;
  if (extraFeatureCustomList) extraFeatureList = extraFeatureCustomList.filter(item => !item.country || item.country === country);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-checkbox-icon ${className}`
  }, extraFeatureList.map((item, i) => (/*#__PURE__*/_react.default.createElement("div", {
    key: `ext_${i.toString()}`,
    className: "brixel-checkbox-icon"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "notranslate",
    "data-validation": validation,
    type: "checkbox",
    id: `${input.name}_${i}`,
    value: item.value,
    name: input.name,
    checked: valArr[item.value] || false,
    onChange: () => onChange(item.value),
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: `${disabled ? 'disabled' : ''} ${valArr[item.value] ? 'checked' : ''} ${pdClass || ''}`,
    htmlFor: `${input.name}_${i}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c leftExtraIcon"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    color: "blue",
    saturationTxt: valArr[item.value] ? 400 : 700,
    iconWidth: "w-fix-24",
    className: `${iconClass || ''}`,
    icon: item.icon
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: `textLabel ${item.icon ? 'ml-1' : ''} ${valArr[item.value] ? 'fweight-500' : ''}`
  }, (0, _translation.default)(item.label, lang, undefined, translations))), /*#__PURE__*/_react.default.createElement("span", {
    className: "checkmark"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    color: "white",
    icon: "check",
    className: 'pl-small-1'
  })))))));
};
const mapStateToProps = state => ({
  translations: (0, _lodash.get)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(BrixelExtraFeatureComponent);